module.exports = __webpack_public_path__ + "img/weChat-1.bc111321.jpg";